module.exports = __webpack_public_path__ + "img/nav-icon-3.9d9408c1.png";